export default class DialogUtils {
  static SMALL = '30%';
  static MEDIUM = '55%';
  static M_LARGE = '70%';
  static LARGE = '80%';
  static X_LARGE = '90%';
}
